import initGallery from "./gallery";
import { triggerHeaderScroll } from "./observers";
import initBooking from "./booking";
import initModal from "./modal";
import triggerPopUp from "./auto-popup";

initGallery();
triggerHeaderScroll();
initBooking();
initModal();
triggerPopUp();

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();
